function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDevDarkMode = function SvgDevDarkMode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 495 495",
    style: {
      enableBackground: "new 0 0 495 495"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffeb99"
    },
    d: "M293.056 247.5c0-109.382-88.672-198.054-198.054-198.054-17.072 0-33.642 2.166-49.446 6.229 55.602 45.385 91.113 114.454 91.113 191.825s-35.51 146.44-91.113 191.825c15.804 4.063 32.373 6.229 49.446 6.229 109.382 0 198.054-88.672 198.054-198.054z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffde55"
    },
    d: "M201.944 0C142.624 0 88.186 20.878 45.556 55.675c15.804-4.063 32.373-6.229 49.446-6.229 109.382 0 198.054 88.672 198.054 198.054S204.384 445.554 95.002 445.554c-17.072 0-33.642-2.166-49.446-6.229C88.186 474.122 142.624 495 201.944 495c136.69 0 247.5-110.81 247.5-247.5S338.634 0 201.944 0z"
  }));
};
export default SvgDevDarkMode;